import React from "react";
import { Button, Image } from "antd";
// import "./styles.scss" // Assuming you are moving away from SCSS styles
import StarRatingIcon from "assets/icons/StarRatingIcon";
import dummyImg1 from "assets/img/prod-1.jpg"; // Placeholder images
import dummyImg2 from "assets/img/prod-2.jpg";
import dummyImg3 from "assets/img/prod-3.jpg";

import { Routes } from "constants/routes";
import { useNavigate } from "react-router-dom";
import { random } from "lodash";
import { BsUnlock } from "react-icons/bs";

const LockedStoreCard: React.FC = () => {
    const navigate = useNavigate();
    const productImg = [dummyImg1, dummyImg2, dummyImg3];
    
    // Choose a random image for the dummy card background
    const selectedImage = productImg[random(0, 2)];

    return (
        // Mimics the horizontal layout of the StoreCard using Tailwind
        <div className="relative shadow-md rounded-xl overflow-hidden flex cursor-pointer">
            
            {/* The Overlay: blurs the background content */}
            <div className="absolute inset-0 bg-white bg-opacity-80 backdrop-blur-sm z-10"></div>
            
            {/* --- Dummy Store Card Content (Visually obscured by overlay) --- */}
            
            {/* image-wrapper: fixed width of 120px */}
            <div className="relative w-[120px] h-[120px] flex-shrink-0">
                <Image
                    src={selectedImage} // Use the random dummy image
                    width={"100%"}
                    height={"100%"}
                    alt={"image"}
                    className="object-cover rounded-tl-lg rounded-bl-lg"
                    preview={false}
                />
            </div>

            {/* store-details */}
            <div className="p-4 bg-white flex flex-grow justify-between rounded-tr-lg rounded-br-lg">
                <div className="flex justify-between w-full">
                    {/* Left side details */}
                    <div className="flex flex-col justify-between">
                        <div>
                            <h5 className="text-lg font-semibold truncate w-48">Dummy Store Name</h5>
                        </div>
                        <div className="flex items-center gap-1 text-sm font-light">
                            <StarRatingIcon />
                            3.3 (233)
                        </div>
                         <div className="text-sm">Total Active Products: 4500</div>
                    </div>
                    
                    {/* Right side stats and buttons container */}
                    <div className="flex flex-col justify-between items-end min-w-[230px]">
                        <div className="sold-units-container w-full">
                            <div className="sold-units mb-2 text-xs font-semibold text-right">
                                Sold Units:
                            </div>
                            <div className="stats-container flex justify-between text-xs text-center gap-5">
                                <div className="flex flex-col items-center">
                                    <span className="text-lg font-semibold">1.2K</span>
                                    <span>Weekly</span>
                                </div>
                                <div className="flex flex-col items-center">
                                    <span className="text-lg font-semibold">4.8K</span>
                                    <span>Monthly</span>
                                </div>
                                <div className="flex flex-col items-center">
                                     <span className="text-lg font-semibold">50K+</span>
                                    <span>All Time</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className="action-btns w-full mt-4">
                            {/* Dummy buttons, won't be visible anyway but maintains structure */}
                            <div className="h-9 bg-gray-100 rounded-lg w-full"></div> 
                            <div className="h-9 bg-gray-100 rounded-lg w-full mt-2"></div> 
                        </div>
                    </div>
                </div>
            </div>

            {/* --- Upgrade Container (Positioned on top of the overlay) --- */}
            
            <div className="absolute inset-0 flex flex-col items-center justify-center z-20 p-8 text-center">
                <h6 className="text-base font-semibold mb-4 text-gray-800">
                    Upgrade your plan to discover more trending stores
                </h6>
                <Button 
                    className="bg-blue-600 text-white hover:bg-blue-700 flex items-center gap-2 px-4 py-2 rounded-lg shadow-md"
                    onClick={() => navigate(Routes.DASHBOARD_BILLING)}
                >
                    <BsUnlock size={15} />
                    Unlock Store
                </Button>
            </div>
        </div>
    );
};

export default LockedStoreCard;
